import * as wf from "client-api-workflow";
import { useQuery } from "react-query";

const useComments = (params: { id: string; period: string }) => {
  return useQuery(
    `data-comments-${params.id}-${params.period}`,
    () => {
      return wf.getComment({
        parentId: params.id,
        period: params.period || "latestforseries",
      });
    },
    {
      enabled: !!params.id && !!params.period,
      cacheTime: 10 * (60 * 1000),
      staleTime: 10 * (60 * 1000),
    }
  );
};

export default useComments;
